<script lang="ts">
  import { onMount } from "svelte";

  import { api, ApiError } from "../../lib/api";
  import { beginLogin, isSignedIn } from "../../lib/auth";
  import { resolveAppConfig } from "../../lib/config";

  let code = $state("");
  let busy = $state(false);
  let result = $state<{ ok: boolean; msg: string } | null>(null);

  onMount(async () => {
    if (!isSignedIn()) {
      const cfg = await resolveAppConfig();
      await beginLogin(cfg.oidc, "/redeem");
    }
  });

  async function submit(e: SubmitEvent) {
    e.preventDefault();
    if (!code.trim()) return;
    busy = true;
    result = null;
    try {
      const r = await api.redeem(code.trim());
      result = r.success
        ? { ok: true, msg: `Redeemed! ${r.plan} active until ${r.valid_until ? new Date(r.valid_until).toLocaleDateString() : ""}` }
        : { ok: false, msg: r.error || "Could not redeem" };
    } catch (e) {
      result = { ok: false, msg: e instanceof ApiError ? e.message : "Redeem failed" };
    } finally {
      busy = false;
    }
  }
</script>

<section class="max-w-md mx-auto px-6 py-16">
  <h1 class="text-3xl font-bold">Redeem a voucher</h1>
  <p class="mt-3 text-slate-400 text-sm">Enter a promo code to unlock Pro access.</p>

  <form onsubmit={submit} class="mt-6">
    <label for="code" class="block text-sm text-slate-300">Voucher code</label>
    <input
      id="code"
      bind:value={code}
      placeholder="NEOSPRO30"
      class="mt-1 w-full rounded-md bg-white/5 border border-white/15 px-3 py-2 outline-none focus:border-indigo-400"
    />
    <button
      type="submit"
      disabled={busy}
      class="mt-4 w-full px-4 py-2 rounded-md bg-indigo-500 hover:bg-indigo-400 text-white disabled:opacity-50"
    >
      {busy ? "Redeeming…" : "Redeem"}
    </button>
  </form>

  {#if result}
    <p class="mt-4 text-sm {result.ok ? 'text-emerald-400' : 'text-red-400'}">
      {result.msg}
    </p>
  {/if}
</section>
